import { Box, Grid } from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import React from 'react';
import StatBox from 'components/StatBox';
import { useGetSalesStatsQuery } from 'state/api';

const Cards = () => {
  const { data, isLoading } = useGetSalesStatsQuery();
  return (
    <Box
      sx={{
        m: 2,
        ml: 0,
      }}
    >
      <Grid container spacing={4} className='flex justify-start'>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Total Sales in this year'
            value={isLoading ? '-' : '₹ ' + data?.total}
            icon={'₹'}
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Number of Sales in a year'
            value={isLoading ? '-' : data?.yearly}
            icon={<CreditCardIcon />}
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border border-[#1F509A]'
            title='Number of Sales in a month'
            value={isLoading ? '-' : data?.monthly}
            icon={<CreditCardIcon />}
            color='#D4EBF8'
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Cards;
